import React, { useEffect, useRef, useState } from "react";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
// import Paper from "@material-ui/core/Paper";
import Box from "@material-ui/core/Box";
import { makeStyles } from "@material-ui/core/styles";
import { DataStore } from "@aws-amplify/datastore";
import { EyepieceTwoResponse } from "models";
import { Auth } from "aws-amplify";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import ListItemText from "@material-ui/core/ListItemText";
import Input from "@material-ui/core/Input";
import Checkbox from "@material-ui/core/Checkbox";
import MenuItem from "@material-ui/core/MenuItem";
// import DeleteIcon from "@material-ui/icons/Delete";
// import Button from "@material-ui/core/Button";
// import MenuItem from "@material-ui/core/MenuItem";
import EyepieceTwoResource from 'components/EyepieceTwoResource';
import Drawing from "components/Drawing";
import DrawingDialog from "components/DrawingDialog";
import { Users } from "models";
import { prepareData, createCharts } from "utils/ep2util";
const useStyles = makeStyles((theme) => ({
  button: {
    marginLeft: theme.spacing(2),
  },
  formControl: {
    marginRight: theme.spacing(4),
    minWidth: 300,
    maxWidth: 400,
  },
  chartTitle: {
    textAlign: "center",
    margin: theme.spacing(2),
  },

  drawingContainer: {
    marginBottom: theme.spacing(4),
  },
}));

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
  imageContainer: {},

  deleteIcon: {
    position: "absolute",
    left: 0,
    right: 0,
  },
};
function EyepieceTwoResult() {
  const classes = useStyles();
  // const [user, setUser] = useState(null);
  const [message, setMessage] = useState(null);
  const [drawings, setDrawings] = useState(null);
  const [allData, setAllData] = useState(null);
  const [data, setData] = useState(null);
  const [otherData, setOtherData] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);
  const [school, setSchool] = useState('');
  const [allSchools, setAllSchools] = useState([]);
  const myChartRefs = useRef([]);
  const otherChartRefs = useRef([]);
  const [showOtherSchool, setShowOtherSchool] = useState(false);
  const [questions, setQuestions] = useState([]);
  const [total, setTotal] = useState(0);
  const [otherTotal, setOtherTotal] = useState(0);
  const [selectedDrawing, setSelectedDrawing] = useState(null);
  useEffect(async () => {
    const user = await Auth.currentAuthenticatedUser();
    console.log("user", user);
    let users = await DataStore.query(Users, (d) =>
      d.email("eq", user.attributes.email)
    );
    const groups = user.signInUserSession.accessToken.payload["cognito:groups"];
    // console.log("ADMIN", groups, groups.indexOf("Admin") !== -1);
    if (groups){
      setIsAdmin(groups.indexOf("Admin") !== -1);
    }
    const school = users[0].school;
    setSchool(school);
    users = await DataStore.query(Users, (d) =>
      d.email("ne", user.attributes.email)
    );

    let allData = await DataStore.query(EyepieceTwoResponse);
    allData = allData.map((r) => {
      return {
        ...r,
        questions: JSON.parse(r.questions),
      };
    });
    console.log("all data", allData);
    setAllData(allData);
    initialize(allData, school);
  }, []);

  // useEffect(() => {
  //   if (!data) {
  //     return;
  //   }
  //   const myDisplayData = filterData(data, questions);
  //   createCharts(myDisplayData, myChartRefs.current, (filteredRecords) => {
  //     setTotal(filteredRecords);
  //   });
  // }, [data]); // called once

  useEffect(() => {
    if (!data) {
      return;
    }
    console.log("myChartRefs", myChartRefs.current.length);
    console.log("otherChartRefs", otherChartRefs.current.length);

    let displayData = filterData(data, questions);
    // console.log('filteredData', filteredData);
    createCharts(displayData, myChartRefs.current, (filteredRecords) => {
      setTotal(filteredRecords);
    });
    console.log("showOtherSchool", showOtherSchool);
    if (showOtherSchool) {
      displayData = filterData(otherData, questions);
      createCharts(
        displayData,
        otherChartRefs.current,
        (filteredRecords) => {
          setOtherTotal(filteredRecords);
        },
        "#bdbdbd",
        "#29b6f6"
      );
    }
  }, [data, otherData, showOtherSchool, questions]);
  function initialize(data, school) {
    let records = data.filter((d) => d.school === school);
    if (records.length === 0) {
      setMessage("Results are not available yet");
      return;
    }
    const allSchools = Array.from(new Set(data.map((d) => d.school)));
    setAllSchools(allSchools);

    // let otherSchools = allSchools.filter((s) => s !== school);
    // let otherSchools = Array.from(new Set(users.map((d) => d.school)));
    console.log(
      "schools",
      school,
      allSchools.filter((s) => s !== school)
    );

    setTotal(records.length);

    let otherRecords = data.filter((d) => d.school !== school);

    setOtherTotal(otherRecords.length);
    // console.log("records", school, records);
    // console.log("otherRecords", otherSchools, otherRecords);
    
    setQuestions(records[0].questions.map((q) => q.question));

    const myData = prepareData(records);
    const otherData = prepareData(otherRecords);
    console.log("myData, otherData", myData, otherData);
    setData(JSON.parse(JSON.stringify(myData)));
    setOtherData(JSON.parse(JSON.stringify(otherData)));
    setDrawings(
      records.map((r) => ({
        id: r.id,
        photo: r.photo,
      }))
    );
  }
  function filterData(data, questions) {
    const filteredData = Object.entries(data)
      .filter((d) => questions.includes(d[0]))
      .reduce((acc, d) => {
        acc[d[0]] = d[1];
        return acc;
      }, {});
    console.log("filteredData", filteredData);
    return filteredData;
  }
  function handleSchoolChange(event) {
    console.log('school', event.target.value);
    setSchool(event.target.value);
    initialize(allData, event.target.value);
  }
  function handleSeeOtherSchool(event) {
    setShowOtherSchool(event.target.checked);
  }
  function handleShowQuestions(e) {
    console.log(questions);
    setQuestions(e.target.value);
  }
  async function handleDrawing(id) {
    console.log("delete", id);
    await DataStore.delete(EyepieceTwoResponse, (response) =>
      response.id("eq", id)
    );
    const newData = Object.entries(data).reduce((acc, [key, value]) => {
      acc[key] = {
        data: value.data.filter((d) => d.responseId !== id),
      };
      return acc;
    }, {});
    console.log("new data", newData);
    setData(newData);
    setDrawings(drawings.filter((d) => d.id !== id));
  }
  
  function handleClickDrawing(drawing){
    setSelectedDrawing(drawing);
  }
  function handleDrawingClose(){
    setSelectedDrawing(null);
  }
  return (
    <Container>
      <DrawingDialog open={selectedDrawing!==null} drawing={selectedDrawing} onClose={handleDrawingClose}/>
      {isAdmin && (
        <Box pb={2}>
          <FormControl className={classes.formControl} margin="normal">
            <InputLabel id="select-school">School</InputLabel>
            <Select
              labelId="select-school"
              id="school-select"
              value={school}
              onChange={handleSchoolChange}
            >
              {allSchools.map((school) => (
                <MenuItem key={school} value={school}>
                  {school}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
      )}
      {message && <Box p={3}>{message}</Box>}
      {drawings && (
        <Grid className={classes.drawingContainer} container spacing={3}>
          {drawings.map((drawing, i) => (
            <Grid key={i} item xs={2}>
              <Drawing
                id={drawing.id}
                drawing={drawing.photo}
                onDelete={handleDrawing}
                onClick={handleClickDrawing}
              />
            </Grid>
          ))}
        </Grid>
      )}
      {data && (
        <Grid container spacing={3}>
          <Grid item xs>
            <FormControl className={classes.formControl} fullWidth>
              <InputLabel id="demo-mutiple-checkbox-label">
                Select questions to visualize
              </InputLabel>
              <Select
                labelId="demo-mutiple-checkbox-label"
                id="demo-mutiple-checkbox"
                multiple
                value={questions}
                onChange={handleShowQuestions}
                input={<Input />}
                renderValue={(selected) => selected.join(", ")}
                MenuProps={MenuProps}
              >
                {Object.keys(data).map((question) => (
                  <MenuItem key={question} value={question}>
                    <Checkbox checked={questions.indexOf(question) > -1} />
                    <ListItemText primary={question} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs>
            <FormControlLabel
              control={
                <Checkbox
                  checked={showOtherSchool}
                  onChange={handleSeeOtherSchool}
                  name="checked"
                  color="primary"
                />
              }
              label="Compare with Other Schools"
            />
          </Grid>
        </Grid>
      )}
      <Grid container>
        <Grid item xs={12}>
          <Grid container>
            <Grid item xs={6}>
              <Box margin={2}>
                <Typography variant="button" gutterBottom>
                  Total Responses: {total}
                </Typography>
              </Box>
            </Grid>
            {showOtherSchool && (
              <Grid item xs={6}>
                <Box margin={2}>
                  <Typography variant="button" gutterBottom>
                    Total Responses (Other Schools): {otherTotal}
                  </Typography>
                </Box>
              </Grid>
            )}
          </Grid>
        </Grid>
        <Grid item xs={12}>
          👉🏻 Click bars, or categories, to filter responses across all questions.<br/>
          👉🏽 Double click the chart to clear the selection
          👌🏿 Use the shift-key to select multiple bars
        </Grid>
        {questions.map((d, i) => {
          return (
            <Grid key={i} item xs={4}>
              <Typography
                className={classes.chartTitle}
                variant="body1"
                display="block"
                gutterBottom
              >
                {d}
              </Typography>
              <Grid container>
                <Grid item xs>
                  {/* <Typography
                  className={classes.chartTitle}
                  variant="body2"
                  gutterBottom
                >
                  My School
                </Typography> */}
                  <Box
                    ref={(el) => (myChartRefs.current[i] = el)}
                    width="100%"
                  ></Box>
                </Grid>
                {showOtherSchool && (
                  <Grid item xs>
                    {/* <Typography
                    className={classes.chartTitle}
                    variant="body2"
                    gutterBottom
                  >
                    Other Schools
                  </Typography> */}
                    <Box
                      ref={(el) => (otherChartRefs.current[i] = el)}
                      width="100%"
                    ></Box>
                  </Grid>
                )}
              </Grid>
            </Grid>
          );
        })}
      </Grid>
    </Container>
  );
}

export default EyepieceTwoResult;
